const Health = () => (
  <svg height="30" viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <defs>
      <clipPath id="clipPath">
        <rect
          data-name="Rectangle 172"
          fill="rgba(255,255,255,0.3)"
          height="30"
          id="Rectangle_172"
          transform="translate(23441 12769)"
          width="30"
        />
      </clipPath>
    </defs>
    <g clipPath="url(#clipPath)" id="health" transform="translate(-23441 -12769)">
      <g data-name="Calque 2" id="Calque_2" transform="translate(23441 12769)">
        <g data-name="Calque 1" id="Calque_1">
          <rect data-name="Rectangle 168" fill="none" height="30" id="Rectangle_168" width="30" />
          <circle cx="15" cy="15" data-name="Ellipse 108" fill="none" id="Ellipse_108" r="15" transform="translate(0 0)" />
          <line data-name="Ligne 214" fill="none" id="Ligne_214" x2="30" y2="30" />
          <line data-name="Ligne 215" fill="none" id="Ligne_215" x1="30" y2="30" />
          <line data-name="Ligne 216" fill="none" id="Ligne_216" transform="translate(0 15)" x2="30" />
          <line data-name="Ligne 217" fill="none" id="Ligne_217" transform="translate(0 7.497)" x2="30" />
          <line data-name="Ligne 218" fill="none" id="Ligne_218" transform="translate(0 22.501)" x2="30" />
          <line data-name="Ligne 219" fill="none" id="Ligne_219" transform="translate(15)" y2="30" />
          <line data-name="Ligne 220" fill="none" id="Ligne_220" transform="translate(7.497)" y2="30" />
          <line data-name="Ligne 221" fill="none" id="Ligne_221" transform="translate(22.501)" y2="30" />
          <rect
            data-name="Rectangle 169"
            fill="none"
            height="21.218"
            id="Rectangle_169"
            transform="translate(4.391 4.391)"
            width="21.218"
          />
          <circle
            cx="10.609"
            cy="10.609"
            data-name="Ellipse 109"
            fill="none"
            id="Ellipse_109"
            r="10.609"
            transform="translate(4.391 4.391)"
          />
          <rect
            data-name="Rectangle 170"
            fill="none"
            height="15.004"
            id="Rectangle_170"
            transform="translate(7.497 7.497)"
            width="15.004"
          />
          <circle
            cx="7.501"
            cy="7.501"
            data-name="Ellipse 110"
            fill="none"
            id="Ellipse_110"
            r="7.501"
            transform="translate(7.499 7.499)"
          />
          <rect
            data-name="Rectangle 171"
            fill="none"
            height="13.109"
            id="Rectangle_171"
            rx="0.647"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            transform="translate(4.801 10.102)"
            width="20.398"
          />
          <path
            d="M15.2,8.292a3.315,3.315,0,1,0-6.63,0"
            data-name="Tracé 1524"
            fill="none"
            id="Tracé_1524"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            transform="translate(3.116 1.81)"
          />
          <path
            d="M16.468,12.2V14.53H13.314v3.155H10.988V14.53H7.834V12.2h3.154V9.049h2.326V12.2Z"
            data-name="Tracé 1525"
            fill="none"
            id="Tracé_1525"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            transform="translate(2.849 3.29)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Health;
